import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

let lenis = null;

export const Layout = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); lenis = null; };
  }, []);

  useEffect(() => {
    const target = hash ? document.querySelector(hash) : null;
    if (target) {
      const go = () => (lenis ? lenis.scrollTo(target, { offset: -90 }) : target.scrollIntoView());
      setTimeout(go, 80);
    } else if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <>
      <a href="#contenu" className="skip-link" data-testid="skip-link">Aller au contenu</a>
      <Header />
      <main id="contenu" tabIndex={-1} className="outline-none">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
      <Toaster position="top-center" richColors />
    </>
  );
};
